import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, lastValueFrom } from 'rxjs';
import { ResourceRequest } from '../../../models/resource.model';
import { ProductDiscounts, ProductRequestRefresher, ProductTabDetails } from '../../../models/product.model';
import { ApiService } from '../api.services';
import { __param } from 'tslib';
import { superAdminHttpRoutes, superAdminHttpVersion } from '../../../consts/super_admin_http_routes';


@Injectable({
  providedIn: 'root'
})
export class ProductService {

  private url: string = superAdminHttpVersion.V1;

  constructor(private _httpClient: HttpClient, private apiService: ApiService,) {
  }

  filter(q: string, sort_by?: string, page_number?: number, page_size?: number, category?: string): Observable<any> {
    let params = new HttpParams();
    params = params.set('q', q);
    if (sort_by) {
      params = params.set('sort_by', sort_by);
    }
    if (page_number) {
      params = params.set('page_number', page_number);
    }
    if (page_size) {
      params = params.set('page_size', page_size);
    }
    if (category) {
      params = params.set('category', category);
    }
    return this._httpClient.get<any>(`${this.url}${superAdminHttpRoutes.PRODUCT_GET_TABLE}`, { params });

  }
  //public
  getProduct(id:string){
    return this._httpClient.get<any>(`${this.url}${superAdminHttpRoutes.GET_PRODUCT}/${id}`);
  }
  //product details
  getProductSummary(id: string) {
    // return this._httpClient.get<any>(`${this.url}/summary/${id}`);
    return this._httpClient.get<any>(`${this.url}${superAdminHttpRoutes.GET_PRODUCT}/${id}`);
  }
  getProductsSummary(q: string, sort_by?: string, page_number?: number, page_size?: number, include_inactive?: boolean, category?: string) {
    let params = new HttpParams();
    params = params.set('q', q);
    if (sort_by) {
      params = params.set('sort_by', sort_by);
    }
    if (include_inactive != null) {
      params = params.set('include_inactive', include_inactive.toString()); // Convert to string
    }
    if (page_number) {
      params = params.set('page_number', page_number);
    }
    if (page_size) {
      params = params.set('page_size', page_size);
    }
    if (category) {
      params = params.set('category', category);
    }
    return this._httpClient.get<any>(`${this.url}${superAdminHttpRoutes.PRODUCT_GET_TABLE}`, { params });
  }
  
  addProductDetails(productDetails:ProductTabDetails){
    return this.apiService.httpPostCall(`${this.url}${superAdminHttpRoutes.GET_PRODUCT}`,productDetails);
  }
  updateProductDetails(id:string,productDetails:ProductTabDetails){
    return this.apiService.httpPutCall(`${this.url}${superAdminHttpRoutes.GET_PRODUCT}/${id}`,productDetails);
  }
  activateProduct(id: string, body: any) {
    return this.apiService.httpPatchCall(`${this.url}product/${id}/status`, body);
  }
  deactivateProduct(id: string, body: any) {
    return this.apiService.httpPatchCall(`${this.url}product/${id}/status`, body);
  }
  
  archiveProduct(id: string,isDelete: boolean){
    const param = { isDelete }; // Add the parameter to the request body
    return this.apiService.httpPatchCall(`${this.url}product/${id}/archive-restore/`, param);
  }



  //multimedia and images

  uploadProductLogo(productId: string, file: File): Observable<any> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("bucketName", "superadmin/test");
    formData.append("dirPath", `product/${productId}`);
    
    return this.apiService.httpPostCall<any>(
      `${this.url}${superAdminHttpRoutes.UPLOAD_PRODUCT_LOGO}`,
      formData
    );
  }
  
  saveMultimedia(id: string, form: any) {
    return this.apiService.httpPostCall<any>(`${this.url}product-multi-media`, form);
  }
  
  deleteMultimedia(idMultimedia: string, isDelete: boolean) {
    const param = { isDelete }; // Add the parameter to the request body
    return this.apiService.httpPatchCall(`${this.url}product-multi-media/${idMultimedia}/archive-restore/`, param);
}

  getMultimediaById(id: string, idMultimedia: string) {
    return this._httpClient.get(`${this.url}/${id}/multimedia/${idMultimedia}`);
  }


  getMultimedia(id: string, q: string, page_number: number, page_size: number): Observable<any> {
    let params = new HttpParams();
    params = params.set('q', q);
    if (page_number) {
        params = params.set('page_number', page_number);
    }
    if (page_size) {
        params = params.set('page_size', page_size);
    }
  
    return this.apiService.httpGetCall(`${this.url}${superAdminHttpRoutes.GET_ALL_MULTIMEDIA}/product-id/${id}/table`, params );
  }
  

  selectMainMultimedia(id: string, idMultimedia: string) {
    return this.apiService.httpGetCallWithoutParameter(`${this.url}product-multi-media/product-id/${id}/multi-media-id/${idMultimedia}`);
  }

  uploadMultimedia(file: File): Observable<any> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("bucketName", "sos-superadmin-portal");
    formData.append("dirPath", `multimedia`);

    return this.apiService.httpPostCall<any>(
      `${this.url}${superAdminHttpRoutes.UPLOAD_PRODUCT_LOGO}`,
      formData
    );
  }
  //resources
  getResources(id: string,  q: string, page_number: number, page_size: number): Observable<ResourceRequest> {
    let params = new HttpParams();
    params = params.set('q', q);
    if (page_number) {
        params = params.set('page_number', page_number);
    }
    if (page_size) {
        params = params.set('page_size', page_size);
    }
    return this.apiService.httpGetCall<ResourceRequest>(`${this.url}product-resource/product-id/${id}/table`, params);
  }

  updateResourcesPosition(resourceId: string, position: number) {
    const requestBody = {
      resourceId: resourceId,
      position: position
    };
  
    return this.apiService.httpPatchCall<ResourceRequest>(`${this.url}product-resource/modify-position`, requestBody);
  }
  
  deleteResources(idResource: string, isDelete: boolean) {
    const param = { isDelete };
    return this.apiService.httpPatchCall(`${this.url}product-resource/${idResource}/archive-restore`, param);
  }
  activeResources(id: string, idResource: string) {
    return this._httpClient.patch(`${this.url}/${id}/resources/${idResource}/enable`, null);
  }
  getResourceById(id: string, idResource: string) {
    return this.apiService.httpGetCallWithoutParameter(`${this.url}product-resource/product-id/${id}/resource-id/${idResource}`);
  }
  addProductResource(productResources: ResourceRequest) {
    return this.apiService.httpPostCall<any>(`${this.url}product-resource`, productResources);
  }
  updateProductResource(productResources: ResourceRequest) {
    return this.apiService.httpPutCall(`${this.url}product-resource`, productResources);
  }
  //add Discount
  addDiscounts(id: string, productDiscounts: ProductDiscounts) {
    return this.apiService.httpPostCall(`${this.url}product-discount/product-id/${id}`, productDiscounts);
  }
  getDiscounts(id: string) {
    return this._httpClient.get(`${this.url}product-discount/product-id/${id}`);
  }
  getDiscountsCart(id: string) {
    return this._httpClient.get(`${this.url}product-discount/product-id/${id}`);
  }


  async deleteDiscounts(discountId: string, isDelete: boolean) {
    const param = { isDelete }; 
    return await lastValueFrom(this.apiService.httpPatchCall(`${this.url}product-discount/${discountId}/archive-restore/`, param));
  }

  getUserQuestions(id: string, q: string, sort_by?: string, page_number?: number, page_size?: number) {
    let params = new HttpParams();
    params = params.set('q', q);
    if (sort_by) {
      params = params.set('sort_by', sort_by);
    }
    if (page_number) {
      params = params.set('page_number', page_number);
    }
    if (page_size) {
      params = params.set('page_size', page_size);
    }
    if (id) {
      params = params.set('productId', id);
    }

    
    return this.apiService.httpGetCall(`${this.url}user-questions/table/get`, params );
  }


  sendUserQuestions(id: string, questionId: string, answer: string) {
    return this.apiService.httpPatchCall<ResourceRequest>(`${this.url}user-questions/${questionId}/product-id/${id}`, { answer: answer });
  }

  //Get all students
  getUsers(id: string, q: string, sort_by?: string, page_number?: number, page_size?: number) {
    let params = new HttpParams();
    params = params.set('q', q);
    if (sort_by) {
      params = params.set('sort_by', sort_by);
    }
    if (page_number) {
      params = params.set('page_number', page_number);
    }
    if (page_size) {
      params = params.set('page_size', page_size);
    }
    return this.apiService.httpGetCall(`${this.url}product/${id}/users/table`, params );
  }

  requestRefresherCourse(id: string, userRequest: ProductRequestRefresher) {
    return this._httpClient.post(`${this.url}/${id}/refresh-course`, userRequest);
  }


  //Get company wise category course
  getCompanyCategoryCourse(q: string, sort_by?: string, page_number?: number, page_size?: number, category?: string,companyId?: string ) {
    let params = new HttpParams();
    params = params.set('q', q);
    if (sort_by) {
      params = params.set('sort_by', sort_by);
    }
    if (page_number) {
      params = params.set('page_number', page_number);
    }
    if (page_size) {
      params = params.set('page_size', page_size);
    }
    if (category) {
      params = params.set('categoryId', category);
    }
    if (companyId){
     params = params.set('companyId', companyId);
    }
    return this.apiService.httpGetCall<any>(`${this.url}${superAdminHttpRoutes.COMPANY_CATEGORY_COURSE_GET_TABLE}`,  params );
  }
}
